export const getSampleMetadataTemplateData = (): string[][] => {
  return [
    ['path', 'id', 'metadata:Material', 'metadata:Color', 'metadata:Weight'],
    ['/domain/assets/part1.sldprt', '12345-67890', 'Steel', 'Blue', '2.5kg'],
    ['/domain/assets/part2.step', '98765-43210', 'Aluminum', 'Red', '1.2kg'],
    ['/domain/assets/assembly.sldasm', '', 'Mixed', '', ''],
  ];
};
